export default __webpack_public_path__ + "static/media/course-1-4.adda3322.jpg";